import React, { Component } from "react";
import Factor from './workbench/Factor/index'
import CoreFirm from './workbench/CoreFirm/index'
// import Supplier from './workbench/Factor/supplier'
import Supplier from './workbench/Supplier/index'

export default class MainIndex extends Component {
  render() {
    return (
      <Factor></Factor>
      // <CoreFirm></CoreFirm>
      // <Supplier></Supplier>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/MainIndex.js